require('./nav.js');
require('./filters.js');
require('./filterspromo.js');
require('./filterportfolio.js');
require('./sliders.js');
require('./corporativo.js');
require('./galeria.js');
require('./tienda.js');
require('./users.js');
require('./gestor.js');
require('./descargas.js');
require('./flotantes.js');
require('./documentos.js');
require('./inscripciones.js');
require('./formdinamicos.js');

//Firma desarrollador

console.group("%c👨‍💻 Desarrollador", "color: teal; font-size: 16px; font-weight: bold;");
console.log("%cEsta web fue desarrollada por Guillermo Tudela", "color: #555; font-size: 13px;");
console.log("%c¿Quieres saber más? Escribe %cguillermo()%c y visita mi sitio personal.",
"color: #777;", "color: orange; font-weight: bold;", "color: inherit;");
console.log(`
╔═════════════════════════════╗
║   guillermotudela.es 👣     ║
╚═════════════════════════════╝
`);
console.groupEnd();

window.guillermo = () => {
window.open('https://guillermotudela.es', '_blank');
};



